/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React, { createContext } from 'react';

export const actionTypes = {
  MENU: 'MENU',
  EDIT: 'EDIT',
  LINK: 'LINK',
  SUMMARY: 'SUMMARY',
  DELETE: 'DELETE',
};

export const CardContext = createContext({});

export default function CardContextProvider(props) {
  return <CardContext.Provider value={props}>{props.children}</CardContext.Provider>;
}
